import React, { useEffect, useState } from 'react';
import { Badge, Button, Card, Col, Image, Rate, Row, Tag, Typography } from 'antd';
import { CalendarOutlined, CheckCircleFilled, ClockCircleOutlined, EnvironmentOutlined } from '@ant-design/icons';
import { FaRegStar } from 'react-icons/fa'; // Assuming you are using react-icons for star
import './style.css';
import { SlCalender } from 'react-icons/sl';
import { FaCheck } from "react-icons/fa6";
import acceptedEngagement from '../../../assets/images/acceptedEngagement.png'
import requestedEngagement from '../../../assets/images/Jobs1.png'
import inProgressBooking from '../../../assets/images/Jobs2.png'
import rejectedBooking from '../../../assets/images/rejectedBooking.png'
import financialImg1 from '../../../assets/images/financialImg1.png'
import financialImg2 from '../../../assets/images/financialImg2.png'
import financialImg3 from '../../../assets/images/financialImg3.png'
import financialImg4 from '../../../assets/images/financialImg4.png'
import { useParams } from 'react-router';
import { ApiCaller, Colors, Fonts } from '../../../config';
import { FaStripe } from "react-icons/fa";
import moment from 'moment';
import { Loader, Modal, ProfileImage } from '../../../components';
import { ServiceProvidersAction } from '../../../store/actions';
import { useDispatch } from 'react-redux';

const { Title, Text } = Typography;

const SPProfileDashboard = () => {

    const { id } = useParams();
    const [isLoading, setIsLoading] = useState(false);
    const [spData, setSpData] = useState(null);
    const dispatch = useDispatch()

    // for acceptance
    const [ismodal, setismodal] = useState(false);
    // for rejection
    const [ismodalReject, setismodalReject] = useState(false);
    // for final confirmation rejection
    const [isrejectconfirm, setrejectconfirm] = useState(false);
    const [isRefresh, setIsRefresh] = useState(false);

    useEffect(() => {
        if (id) {
            (async () => {
                setIsLoading(true)
                try {
                    let resp = await ApiCaller.Get(`/admin/service-provider/${id}`);
                    setSpData(resp?.data?.data?.serviceProvider)
                }
                catch (error) {
                    console.log(error)
                }
                finally {
                    setIsLoading(false)
                }
            })()
        }
    }, [id, isRefresh])

    console.log("provider info", spData)


    // on click on approve for business proff
    const handleProofOfBusiness = () => {
        setismodal(!ismodal);
    }

    // on click on reject for business proff
    const RejectApproveOfUser = () => {
        setismodalReject(true)
    }

    const handlerejectionapprove = () => {
        setismodalReject(false);
        setrejectconfirm(true)
    }

    const handlerejectioncancel = () => {
        setismodalReject(false);
    }

    const handlerejectionconfirmation = () => {
        setrejectconfirm(false)
        setismodalReject(false)
    }

    const handlerejectionconfirmationapproved = (reason) => {
        const payload = {
            status: 2,
            reason: reason
        }
        dispatch(ServiceProvidersAction.updateServiceProviderBusinessDocumentStatus(spData?.id, payload, () => {
            setIsRefresh(!isRefresh)
        }))
        setrejectconfirm(false)
    }

    // on click of accept from an opened modal 
    const setisbusinessdoc = (id, status) => {
        const payload = {
            status: 1
        }
        setismodal(false)
        dispatch(ServiceProvidersAction.updateServiceProviderBusinessDocumentStatus(id, payload, () => {
            setIsRefresh(!isRefresh)
        }))
    }

    return (
        <div className="sp-profile-dashboard-container">
            {
                isLoading ?
                    <div className='loader table-loader-container'>
                        <Loader.Circular />
                    </div>
                    :
                    <>
                        {/* User Header Section */}
                        <div className="sp-profile-header-section">
                            <div className='sp-about-main-info-container'>
                                <div className='sp-about-info-container'>
                                    <div className='status-container'>
                                        <Tag
                                            color={spData?.verified ? '#FAB700' : '#f50'}
                                        >
                                            {
                                                spData?.verified ? 'Verified' : 'Not-Verified'
                                            }
                                        </Tag>
                                    </div>
                                    <ProfileImage
                                        asAvatar
                                        size={100}
                                        src={spData?.profilePicture}
                                        className="profile-avatar"
                                    />
                                    <Title level={4} className="user-name">{spData?.businessName ?? '-'}</Title>
                                    <Text className="user-contact-info">{spData?.email ?? '-'} | {spData?.phoneNo ?? '-'}</Text>
                                    <Text className="user-address">{spData?.location ?? '-'}</Text>
                                    <Text className="user-status">Service Provider</Text>
                                    <div className="booking-stats">
                                        <div className="booking-stat-item">
                                            <span className="stat-number">{spData?.totalServicesOffered ?? 0}</span>
                                            <span className="stat-label">Number of Jobs Completed</span>
                                        </div>
                                        <div className='section-divider'></div>
                                        <div className="booking-stat-item">
                                            <span className="stat-rating">
                                                <Rate allowClear={false} allowHalf={true} count={5} value={spData?.averageRating} disabled={true} />
                                                <span>{spData?.averageRating?.toFixed(2)}</span>
                                                <span>{'(' + spData?.ratingCount + ')'}</span>
                                            </span>
                                            <span className="stat-label">Average Rating</span>
                                        </div>
                                    </div>
                                </div>

                                {/* Account & Platform Details Section */}
                                <div className='sp-account-document-container'>
                                    <Card className="sp-account-card">
                                        <Title level={5} className="card-title">Account & Platform Details</Title>
                                        <Row gutter={[16, 16]} align="middle" style={{ gap: '20px' }}>
                                            <Col>
                                                <div className="detail-item">
                                                    <span className='calendar-icon-container'>
                                                        <SlCalender color='#fff' />
                                                    </span>
                                                    <div className="detail-text-container">
                                                        <Text className="detail-label">Date Joined</Text>
                                                        <Text className="detail-value">{spData?.dateOfJoining ? moment(spData?.dateOfJoining)?.format('DD MMM YYYY') : '-'}</Text>
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col>
                                                <div className="detail-item">
                                                    {/* <ClockCircleOutlined className="detail-icon" /> */}
                                                    <div className="detail-text-container">
                                                        <Text className="detail-label">Account Status:</Text>
                                                        <Button type="primary" className={`status-button active-status ${spData?.accountStatusLabel == 'BAN' && 'banned-status'}`}>{spData?.accountStatusLabel == 'BAN' ? 'Banned' : spData?.accountStatusLabel ? spData?.accountStatusLabel : '-'}</Button>
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Card>

                                    {/* this Business proff handling code is the same code paste it here from the provider management detail */}
                                    {
                                        spData?.status !== 2 && spData?.proofOfBusinessThumb ?
                                            <div className="mr-10 mb-10 document-container">
                                                <div className="flex-column document-content">
                                                    <Title level={5} className="card-title">proof of business</Title>
                                                    <div style={{ width: '100%' }}>
                                                        {/* original image is needed */}
                                                        <Image
                                                            // width={200}
                                                            className="services-img"
                                                            style={{ borderRadius: '37px', cursor: 'pointer', width: '100%', objectFit: "cover" }}
                                                            preview={{
                                                                src: spData?.proofOfBusiness,
                                                            }}
                                                            src={spData?.proofOfBusiness}
                                                            fallback=''
                                                        />
                                                    </div>

                                                    {
                                                        spData?.status === 0 ?
                                                            <div className='document-action-button-container' >
                                                                <div>
                                                                    <Button
                                                                        style={{
                                                                            padding: "5px 22px",
                                                                            borderRadius: "10px",
                                                                            backgroundColor: Colors.Green,
                                                                            color: Colors.White,
                                                                            fontSize: "13px",
                                                                            fontFamily: Fonts["Poppins-Medium"],
                                                                            fontWeight: 400,
                                                                            cursor: "pointer",
                                                                            textTransform: "capitalize",
                                                                        }}
                                                                        onClick={handleProofOfBusiness}
                                                                    >
                                                                        Approve
                                                                    </Button>
                                                                </div>

                                                                <div>
                                                                    <Button
                                                                        style={{
                                                                            padding: "5px 30px",
                                                                            borderRadius: "10px",
                                                                            backgroundColor: Colors.Pink,
                                                                            color: Colors.White,
                                                                            fontSize: "13px",
                                                                            fontFamily: Fonts["Poppins-Medium"],
                                                                            fontWeight: 400,
                                                                            cursor: "pointer",
                                                                            textTransform: "capitalize",
                                                                        }}
                                                                        onClick={RejectApproveOfUser}
                                                                    >Reject</Button>
                                                                </div>
                                                            </div>
                                                            :
                                                            spData?.status === 1 ?
                                                                ""
                                                                :
                                                                ""
                                                    }
                                                </div>
                                            </div>
                                            : ""
                                    }

                                    <Modal.ConfirmationModal
                                        style={{ height: "50px", width: "50px" }}
                                        centered={true}
                                        title={""}
                                        isModalVisible={ismodal}
                                        heading={"Are you sure you want to approve document?"}
                                        handleCancel={() => setismodal(false)}
                                        handleDelete={() => setisbusinessdoc(spData?.id, spData?.status)}
                                    />

                                    <Modal.ConfirmationModal
                                        style={{ height: "50px", width: "50px" }}
                                        centered={true}
                                        title={""}
                                        isModalVisible={ismodalReject}
                                        heading={"Are you sure you want to reject document?"}
                                        handleCancel={handlerejectioncancel}
                                        handleDelete={handlerejectionapprove}
                                    />

                                    <Modal.InputModal
                                        centered={true}
                                        heading={"Reason of Rejection"}
                                        subHeading={"Reason"}
                                        isModalVisible={isrejectconfirm}
                                        handleCancel={handlerejectionconfirmation}
                                        handleDelete={handlerejectionconfirmationapproved}
                                    />
                                </div>
                            </div>



                            {/* Direct Booking Section */}
                            <Card className="engagement-card">
                                <Title level={5} className="card-title">Direct Booking</Title>
                                <div className="engagement-stats-container">
                                    <div className='engagement-stat-item'>
                                        <div className='engagement-icon'>
                                            <img src={requestedEngagement} />
                                        </div>
                                        <div className="engagement-content">
                                            <span className="engagement-number requested-number">{spData?.directBookingStats?.pending}</span>
                                            <Text className="engagement-label">Pending</Text>
                                        </div>
                                    </div>
                                    <div className='engagement-stat-item'>
                                        <div className='engagement-icon'>
                                            <img src={inProgressBooking} />
                                        </div>
                                        <div className="engagement-content">
                                            <span className="engagement-number accepted-number">{spData?.directBookingStats?.inProgress}</span>
                                            <Text className="engagement-label">In-progress</Text>
                                        </div>
                                    </div>
                                    <div className='engagement-stat-item' style={{ border: "1px solid #008927" }}>
                                        <div className='engagement-icon'>
                                            <img src={acceptedEngagement} />
                                        </div>
                                        <div className="engagement-content">
                                            <span className="engagement-number accepted-number">{spData?.directBookingStats?.completed}</span>
                                            <Text className="engagement-label">Completed</Text>
                                        </div>
                                    </div>
                                    <div className='engagement-stat-item' style={{ border: "1px solid #A50000" }}>
                                        <div className='engagement-icon'>
                                            <img src={rejectedBooking} />
                                        </div>
                                        <div className="engagement-content">
                                            <span className="engagement-number accepted-number">{spData?.directBookingStats?.rejected}</span>
                                            <Text className="engagement-label">Rejected</Text>
                                        </div>
                                    </div>
                                </div>
                            </Card>

                            {/* in Direct Booking Section */}
                            <Card className="engagement-card">
                                <Title level={5} className="card-title">In-Direct Booking</Title>
                                <div className="engagement-stats-container">
                                    <div className='engagement-stat-item'>
                                        <div className='engagement-icon'>
                                            <img src={requestedEngagement} />
                                        </div>
                                        <div className="engagement-content">
                                            <span className="engagement-number requested-number">{spData?.indirectBookingStats?.pending}</span>
                                            <Text className="engagement-label">Pending</Text>
                                        </div>
                                    </div>
                                    <div className='engagement-stat-item' style={{ border: "1px solid #008927" }}>
                                        <div className='engagement-icon'>
                                            <img src={acceptedEngagement} />
                                        </div>
                                        <div className="engagement-content">
                                            <span className="engagement-number accepted-number">{spData?.indirectBookingStats?.accepted}</span>
                                            <Text className="engagement-label">Accepted</Text>
                                        </div>
                                    </div>
                                </div>
                            </Card>

                            {/* Financial Information Section */}
                            <Card className="engagement-card">
                                <Title level={5} className="card-title">Financial Information</Title>
                                <div className="engagement-stats-container">
                                    <div className='engagement-stat-item' style={{ border: "1px solid #00B517" }}>
                                        <div className='engagement-icon'>
                                            <img src={financialImg1} />
                                        </div>
                                        <div className="engagement-content">
                                            <span className="engagement-number requested-number">{spData?.financialInformation?.totalEarnings}</span>
                                            <Text className="engagement-label">Total Earnings</Text>
                                        </div>
                                    </div>
                                    <div className='engagement-stat-item' style={{ border: "1px solid #FAB700" }}>
                                        <div className='engagement-icon'>
                                            <img src={financialImg2} />
                                        </div>
                                        <div className="engagement-content">
                                            <span className="engagement-number accepted-number">{spData?.financialInformation?.pendingPayouts}</span>
                                            <Text className="engagement-label">Pending Payouts</Text>
                                        </div>
                                    </div>
                                    <div className='engagement-stat-item' style={{ border: "1px solid #00B2DD" }}>
                                        <div className='engagement-icon'>
                                            <img src={financialImg3} />
                                        </div>
                                        <div className="engagement-content">
                                            <span className="engagement-number accepted-number">{spData?.financialInformation?.commissionPaid}</span>
                                            <Text className="engagement-label">Commission Paid</Text>
                                        </div>
                                    </div>
                                    <div className='engagement-stat-item' style={{ border: "1px solid #BCA400" }}>
                                        <div className='engagement-icon'>
                                            <img src={financialImg4} />
                                        </div>
                                        <div className="engagement-content">
                                            {/* <span className="engagement-number accepted-number"> */}
                                            <FaStripe size={45} color='#00B2DD' />
                                            {/* </span> */}
                                            <Text className="engagement-label">Payment Method</Text>
                                        </div>
                                    </div>
                                </div>
                            </Card>

                        </div>

                        {/* Account & Platform Details Section */}
                        {/* <Card className="sp-account-card">
                            <Title level={5} className="card-title">Account & Platform Details</Title>
                            <Row gutter={[16, 16]} align="middle" style={{ gap: '20px' }}>
                                <Col>
                                    <div className="detail-item">
                                        <span className='calendar-icon-container'>
                                            <SlCalender color='#fff' />
                                        </span>
                                        <div className="detail-text-container">
                                            <Text className="detail-label">Date Joined</Text>
                                            <Text className="detail-value">{spData?.dateOfJoining ? moment(spData?.dateOfJoining)?.format('DD MMM YYYY') : '-'}</Text>
                                        </div>
                                    </div>
                                </Col>
                                <Col>
                                    <div className="detail-item">
                                        {/* <ClockCircleOutlined className="detail-icon" /> */}
                        {/* <div className="detail-text-container">
                                            <Text className="detail-label">Account Status:</Text>
                                            <Button type="primary" className="status-button active-status">{spData?.accountStatusLabel ?? '-'}</Button>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Card>  */}

                        {/* Type of Services Booked Section */}
                        <Card className="services-card">
                            <Title level={5} className="card-title">Services</Title>
                            <Row gutter={[16, 16]}>
                                {
                                    spData?.servicesOffered?.length > 0
                                        ?
                                        spData?.servicesOffered?.map((service) => {
                                            return (
                                                <Col xs={12} sm={8} md={4} key={service?.id}>
                                                    <div className="service-type-item">
                                                        <span className='services-icon-container'>
                                                            <FaCheck color='#fff' size={10} />
                                                        </span>
                                                        <Text>{service?.name}</Text>
                                                    </div>
                                                </Col>
                                            )
                                        })
                                        :
                                        <p>No services offered</p>
                                }
                            </Row>
                        </Card>

                        {/* opening hours */}
                        <Card style={{ marginTop: '1.2rem' }}>
                            <Title level={5} className="card-title">Opening hours</Title>
                            <Row gutter={[8, 6]} className=''>
                                {
                                    spData?.openingHours?.length > 0
                                        ?
                                        <div className="hours-table-container hours-table-bordered">
                                            {spData?.openingHours?.map((hours) => (
                                                <Row key={hours?.id} className="hours-table-row">
                                                    <Col xs={12} sm={12} md={12} className="hours-day-column">
                                                        <div className="hours-cell">
                                                            <Text className="day-text">{hours?.day}:</Text>
                                                        </div>
                                                    </Col>
                                                    <Col xs={12} sm={12} md={12} className="hours-time-column">
                                                        <div className="hours-cell">
                                                            {hours?.closed ? (
                                                                <Text style={{ color: Colors.Danger }} className="status-text">
                                                                    closed
                                                                </Text>
                                                            ) : hours?.fullDay ? (
                                                                <Text style={{ color: Colors.Green }} className="status-text">
                                                                    24 hours
                                                                </Text>
                                                            ) : (
                                                                <Text className="time-text">
                                                                    {hours?.startTime ?? '-'} to {hours?.endTime ?? '-'}
                                                                </Text>
                                                            )}
                                                        </div>
                                                    </Col>
                                                </Row>
                                            ))}
                                        </div>
                                        :
                                        <p>No hours added</p>
                                }
                            </Row>
                        </Card>

                        {/* <Card>
                <Title level={5} className="card-title">Services Area</Title>
                <Row gutter={[8, 6]}>
                    <Col xs={24}>
                        <div>
                            <Text>Sandhurst 14-16 Vulcan Way, GU47 9DB</Text>
                        </div>
                    </Col>
                </Row>
            </Card> */}

                        {/* Direct Booking Section
                        <Card className="engagement-card">
                            <Title level={5} className="card-title">Direct Booking</Title>
                            <div className="engagement-stats-container">
                                <div className='engagement-stat-item'>
                                    <div className='engagement-icon'>
                                        <img src={requestedEngagement} />
                                    </div>
                                    <div className="engagement-content">
                                        <span className="engagement-number requested-number">{spData?.directBookingStats?.pending}</span>
                                        <Text className="engagement-label">Pending</Text>
                                    </div>
                                </div>
                                <div className='engagement-stat-item'>
                                    <div className='engagement-icon'>
                                        <img src={inProgressBooking} />
                                    </div>
                                    <div className="engagement-content">
                                        <span className="engagement-number accepted-number">{spData?.directBookingStats?.inProgress}</span>
                                        <Text className="engagement-label">In-progress</Text>
                                    </div>
                                </div>
                                <div className='engagement-stat-item' style={{ border: "1px solid #008927" }}>
                                    <div className='engagement-icon'>
                                        <img src={acceptedEngagement} />
                                    </div>
                                    <div className="engagement-content">
                                        <span className="engagement-number accepted-number">{spData?.directBookingStats?.completed}</span>
                                        <Text className="engagement-label">Completed</Text>
                                    </div>
                                </div>
                                <div className='engagement-stat-item' style={{ border: "1px solid #A50000" }}>
                                    <div className='engagement-icon'>
                                        <img src={rejectedBooking} />
                                    </div>
                                    <div className="engagement-content">
                                        <span className="engagement-number accepted-number">{spData?.directBookingStats?.rejected}</span>
                                        <Text className="engagement-label">Rejected</Text>
                                    </div>
                                </div>
                            </div>
                        </Card>

                        {/* in Direct Booking Section */}
                        {/* <Card className="engagement-card">
                            <Title level={5} className="card-title">In-Direct Booking</Title>
                            <div className="engagement-stats-container">
                                <div className='engagement-stat-item'>
                                    <div className='engagement-icon'>
                                        <img src={requestedEngagement} />
                                    </div>
                                    <div className="engagement-content">
                                        <span className="engagement-number requested-number">{spData?.indirectBookingStats?.pending}</span>
                                        <Text className="engagement-label">Pending</Text>
                                    </div>
                                </div>
                                <div className='engagement-stat-item' style={{ border: "1px solid #008927" }}>
                                    <div className='engagement-icon'>
                                        <img src={acceptedEngagement} />
                                    </div>
                                    <div className="engagement-content">
                                        <span className="engagement-number accepted-number">{spData?.indirectBookingStats?.accepted}</span>
                                        <Text className="engagement-label">Accepted</Text>
                                    </div>
                                </div>
                            </div>
                        </Card> */}

                        {/* Financial Information Section */}
                        {/* <Card className="engagement-card">
                            <Title level={5} className="card-title">Financial Information</Title>
                            <div className="engagement-stats-container">
                                <div className='engagement-stat-item' style={{ border: "1px solid #00B517" }}>
                                    <div className='engagement-icon'>
                                        <img src={financialImg1} />
                                    </div>
                                    <div className="engagement-content">
                                        <span className="engagement-number requested-number">{spData?.financialInformation?.totalEarnings}</span>
                                        <Text className="engagement-label">Total Earnings</Text>
                                    </div>
                                </div>
                                <div className='engagement-stat-item' style={{ border: "1px solid #FAB700" }}>
                                    <div className='engagement-icon'>
                                        <img src={financialImg2} />
                                    </div>
                                    <div className="engagement-content">
                                        <span className="engagement-number accepted-number">{spData?.financialInformation?.pendingPayouts}</span>
                                        <Text className="engagement-label">Pending Payouts</Text>
                                    </div>
                                </div>
                                <div className='engagement-stat-item' style={{ border: "1px solid #00B2DD" }}>
                                    <div className='engagement-icon'>
                                        <img src={financialImg3} />
                                    </div>
                                    <div className="engagement-content">
                                        <span className="engagement-number accepted-number">{spData?.financialInformation?.commissionPaid}</span>
                                        <Text className="engagement-label">Commission Paid</Text>
                                    </div>
                                </div>
                                <div className='engagement-stat-item' style={{ border: "1px solid #BCA400" }}>
                                    <div className='engagement-icon'>
                                        <img src={financialImg4} />
                                    </div>
                                    <div className="engagement-content">
                                        {/* <span className="engagement-number accepted-number"> */}
                        {/* <FaStripe size={45} color='#00B2DD' /> */}
                        {/* </span> */}
                        {/* <Text className="engagement-label">Payment Method</Text>
                                    </div>
                                </div>
                            </div>
                        </Card>   */}

                        <Card className="reviews-card" style={{ marginTop: '1.2rem' }}>
                            <Title level={5} className="card-title">Reviews</Title>
                            <div className="review-container-wrapper">
                                {/* Review */}
                                {
                                    spData?.reviews?.rows?.length > 0 ?
                                        spData?.reviews?.rows?.map((review) => {
                                            return (
                                                <>
                                                    <div className="review-group" key={review?.id}>

                                                        <div className="review-item">
                                                            <ProfileImage asAvatar size={40} src={review?.user?.imageThumbUrl} className="review-avatar" />
                                                            <div className="review-content">
                                                                <div className="review-header">
                                                                    <span className="reviewer-name">{review?.user?.fullName}</span>
                                                                </div>
                                                                <div className="rating">
                                                                    <Rate value={review?.rating} allowHalf={true} count={5} disabled />
                                                                </div>
                                                                <Text className="review-date">{moment(review?.createdAt)?.format('DD MMM YYYY')} | {moment(review?.createdAt)?.format('HH:MM')}</Text>
                                                                <Text className="review-text">
                                                                    {review?.comment}
                                                                </Text>
                                                            </div>
                                                        </div>
                                                        {/* Nested Reply */}
                                                        {
                                                            review?.replyUserId !== null &&
                                                            <div className="review-item nested">
                                                                <ProfileImage asAvatar size={40} src={review?.replyUser?.imageThumbUrl} className="review-avatar" />
                                                                <div className="review-content">
                                                                    <div className="review-header">
                                                                        <span className="reviewer-name">{review?.replyUser?.fullName}</span>
                                                                    </div>
                                                                    <Text className="review-text">
                                                                        {review?.reply}
                                                                    </Text>
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>

                                                    <div className="divider"></div>
                                                </>
                                            )
                                        })
                                        :
                                        <p>No reviews</p>
                                }
                            </div>
                        </Card>
                    </>
            }
        </div>
    );
};

export default SPProfileDashboard;